module.exports = __webpack_public_path__ + "img/RedMissile-Bag100-250.9e9984f9.jpg";